// The units of measure a product can be sold or rented in, as DGII Tabla IV codes (see unidadesMedida.js):
// Unidad (the default), Cilindro, Caja, Paquete, Par, Conjunto and Día. Keep in step with backend/data/productUnits.js.
export const PRODUCT_UNIT_CODES = [43, 9, 6, 31, 32, 10, 12];
export const DEFAULT_UNIT_CODE = 43; // Unidad
